import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import Websocket from 'react-websocket';
import PulsoidClient from '../../PulsoidClient';
import {resolveWidget} from '../configuration/utils';

export const TwitchCon = ({}) => {
  const [heartRate, setHeartRate] = useState(0);
  const [widget, setWidget] = useState(0);

  useEffect(() => {
    document
      .getElementById('fullscreen-btn')
      .addEventListener('click', goFullScreen);

    function goFullScreen() {
      var video = document.getElementById('containertwitchcon');
      var rfs =
        video.requestFullscreen ||
        video.webkitRequestFullScreen ||
        video.mozRequestFullScreen ||
        video.msRequestFullscreen;
      rfs.call(video);
    }

    new PulsoidClient({publicRpc: true})
      .getWidget('809c6d66-edc2-424f-8da9-9380c6f07d5f')
      .then((widget) => setWidget(widget));
    return () => {};
  }, []);

  const handleData = (e) => setHeartRate(JSON.parse(e).data.heartRate);

  return (
    <>
      <style>
        {` 	#containertwitchcon {
                width: 300px;
                height: 170px;
                position: relative;
              }
              
              #large-video {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
              }
              
              #small-video {
                position: absolute;
                bottom: 30%;
                right: 70%;
                width: 30%;
                height:10%;
              }
              `}
      </style>
      <Websocket
        reconnectIntervalInMilliSeconds={3000}
        url={
          'wss://ramiel2.pulsoid.net/listen/a541b945-3f19-4c70-a7c8-028a0e4dc80c'
        }
        onMessage={handleData}
      />
      <div id="containertwitchcon">
        <video
          id="large-video"
          src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/twitchcon/TWITCHCONVIDEOV222.mp4"
          autoPlay
          loop
          type="video/mpeg"
          controls
        ></video>

        <div id="small-video">
          {widget &&
            heartRate != 0 &&
            resolveWidget(
              widget.configuration,
              widget.metaId,
              'test',
              heartRate,
              false
            )}
        </div>
      </div>
      <button id="fullscreen-btn">Go full screen</button>
    </>
  );
};
